import i18n from "@mirage/translations";

export const PROMOTION_STATIC_QUERY_SUGGESTION_COPY = i18n.t(
  "assistant_empty_chat_promotion_suggestion",
);
